import { chargingTransactionActionTypes } from "../../actionTypes/transactions/chargingTransaction.actionTypes";

const initialState = {
  loading: false,
  error: null,
  chargingTransaction: null,
};

const chargingTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case chargingTransactionActionTypes.SET_CHARGING_TRANSACTION:
      return {
        ...state,
        loading: false,
        chargingTransaction: action.payload,
      };

    default:
      return state;
  }
};

export default chargingTransactionReducer;
